
<label class="widget widget-toggle" [class.danger]="danger" [class.success]="success">
    <input
        type="checkbox"
        [name]="name"
        [disabled]="disabled"
        (ngModelChange)="onValueChange($event)"
        [(ngModel)]="value">
    <span class="widget-toggle-slider"></span>
</label>
